export class NotificationModel {
  testCount: number;
  isNewMessage: boolean;
  RcvCnt: number;
  ShpCnt: number;
  LentDelayCnt: number;
  CollLackCnt: number;
}



// WEBPACK FOOTER //
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/app/shared/header-navigation/notification.model.ts